export interface PurchaseNotice {
  name: string
  location: string
}

export const purchases: PurchaseNotice[] = [
  { name: 'Ashley M.', location: 'Charlotte, North Carolina' },
  { name: 'Megan R.', location: 'Phoenix, Arizona' },
  { name: 'Brittany S.', location: 'Nashville, Tennessee' },
  { name: 'Laura P.', location: 'San Diego, California' },
  { name: 'Kelly D.', location: 'Columbus, Ohio' },
  { name: 'Amanda T.', location: 'Austin, Texas' },
  { name: 'Nicole B.', location: 'Denver, Colorado' },
  { name: 'Rachel K.', location: 'Tampa, Florida' },
  { name: 'Stephanie L.', location: 'Portland, Oregon' },
  { name: 'Christina G.', location: 'Boston, Massachusetts' },
  { name: 'Jennifer A.', location: 'Chicago, Illinois' },
  { name: 'Samantha W.', location: 'Atlanta, Georgia' },
]
